import $ from 'jquery';

$(function() {
    // Function to equalize heights within each set of three cards or single card per row on mobile
    
    function equalizeHeights() {
        // Clear existing heights
        $("#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo, " +
          "#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo__content, " +
          "#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo__content h2").css('height', '');

        // Determine if the device is mobile based on window width
        var isMobile = $(window).width() < 768;

        // Process cards
        $("#wsFilterEvents .col-sm-4.fa-filter-content__item").each(function(index) {
            if (isMobile || index % 3 === 0) {
                var maxHeightPromo = 0;
                var maxHeightContent = 0;
                var maxHeightH2 = 0;
                var cardSet = [];

                // Collect the next set of cards (3 for desktop, 1 for mobile)
                for (var i = 0; i < (isMobile ? 1 : 3); i++) {
                    var card = $("#wsFilterEvents .col-sm-4.fa-filter-content__item").eq(index + i);
                    if (card.length > 0) {
                        cardSet.push(card);
                        
                        var promoHeight = card.find(".fa-content-promo").outerHeight();
                        var contentHeight = card.find(".fa-content-promo__content").outerHeight();
                        var h2Height = card.find(".fa-content-promo__content h2").outerHeight();
                        
                        if (promoHeight > maxHeightPromo) {
                            maxHeightPromo = promoHeight;
                        }
                        if (contentHeight > maxHeightContent) {
                            maxHeightContent = contentHeight;
                        }
                        if (h2Height > maxHeightH2) {
                            maxHeightH2 = h2Height;
                        }
                    }
                }

                // Set the height of each element to the maximum height
                for (var i = 0; i < cardSet.length; i++) {
                    cardSet[i].find(".fa-content-promo").css('height', maxHeightPromo);
                    cardSet[i].find(".fa-content-promo__content").css('height', maxHeightContent);
                    cardSet[i].find(".fa-content-promo__content h2").css('height', maxHeightH2);
                }
            }
        });
    }

    // Call the equalizeHeights function initially
    equalizeHeights();

    // Recalculate heights on window resize
    $(window).resize(function() {
        equalizeHeights();
    });
});


// WEBPACK FOOTER //
// ./components/ws-events/scripts/event-cards.js